import { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  InputLabel,
  Snackbar,
  TextField,
} from '@mui/material';
import useAxiosConfig from '../../config/AxiosConfig';

const GroundSettlePaymentModal = (props) => {
  const {
    isSettleModalOpen,
    handleRefetch,
    handleCloseSettleModal,
    selectedGround,
  } = props;
  const axiosInstance = useAxiosConfig();
  const [addStatus, setAddStatus] = useState(null);
  const [amountSettle, setAmountSettle] = useState();
  const [error, setError] = useState(null);
  const [note, setNote] = useState('');
  const [noteError, setNoteError] = useState(null);
  const [isSettle, setIsSettle] = useState(false);
  const handleclose = () => {
    setAmountSettle(null);
    setError(null);
    setNote('');
    setNoteError(null);
    setIsSettle(false);
    handleCloseSettleModal();
  };
  const handleClickSettleAmount = async () => {
    if (amountSettle > selectedGround.groundWallet) {
      setAddStatus({
        message: 'Ground wallet amount too Low !',
        success: false,
      });
      handleclose();
      return;
    }
    try {
      const response = await axiosInstance.post(
        `api/admin/ground-payout?groundId=${selectedGround._id}&amountSelleted=${amountSettle}&notes=${note}`
      );
      console.log('response', response);
      if (response.status == 200 && response.data.status) {
        setAddStatus({
          message: 'Settle payment successfuly',
          success: true,
        });
        handleRefetch(); // Refresh data after successful payout
      } else {
        setAddStatus({
          message: response.data.message,
          success: false,
        });
      }
    } catch (err) {
      setError('Failed to settle payment.');
      return; // Do not close modal if error
    }
    handleclose();
  };
  return (
    <>
      {addStatus !== null && (
        <Box>
          <Snackbar
            open={true}
            autoHideDuration={5000}
            onClose={() => setAddStatus(null)}
          >
            <Alert
              severity={addStatus.success ? 'success' : 'error'}
              onClose={() => setAddStatus(null)}
            >
              {addStatus.message}
            </Alert>
          </Snackbar>
        </Box>
      )}
      <Dialog
        open={!!isSettleModalOpen}
        onClose={handleclose}
        maxWidth='sm'
        fullWidth
        // minHeight='lg'
      >
        <DialogTitle sx={{ textAlign: 'center' }}>Settle Payment</DialogTitle>
        <DialogContent
        // style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          <div className='flex flex-col gap-3'>
            {isSettle ? (
              <>
                <p className='sm:text-sm text-center'>
                  Are you sure you want to settle payment for this ground?
                </p>
                <div className='flex justify-center gap-3'>
                  <Button
                    variant='contained'
                    color='success'
                    size='small'
                    onClick={() => handleClickSettleAmount()}
                  >
                    {'Confirm'}
                  </Button>
                  <Button
                    variant='contained'
                    color='error'
                    size='small'
                    onClick={handleclose}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            ) : (
              <div className='flex flex-col items-center w-full'>
                <div className='w-full'>
                  <InputLabel required>Settle Amount</InputLabel>
                  <TextField
                    fullWidth
                    placeholder='Enter Settlement Amount'
                    variant='outlined'
                    type='number'
                    name='Settle Amount'
                    value={amountSettle}
                    helperText={error}
                    error={!!error}
                    onChange={(e) => setAmountSettle(e.target.value)}
                    sx={{
                      '& label.Mui-focused': { color: '#0C7240' },
                      '& .MuiInput-underline:after': {
                        borderBottomColor: '#0C7240',
                      },
                      marginY: '10px',
                    }}
                  />
                  <InputLabel required sx={{ marginTop: '10px' }}>
                    Note
                  </InputLabel>
                  <TextField
                    fullWidth
                    placeholder='Enter Note'
                    variant='outlined'
                    type='text'
                    name='Note'
                    value={note}
                    helperText={noteError}
                    error={!!noteError}
                    onChange={(e) => {
                      setNote(e.target.value);
                      if (e.target.value) setNoteError(null);
                    }}
                    sx={{
                      '& label.Mui-focused': { color: '#0C7240' },
                      '& .MuiInput-underline:after': {
                        borderBottomColor: '#0C7240',
                      },
                      marginY: '10px',
                    }}
                    required
                  />
                  <div className='flex justify-center gap-3 mt-4'>
                    <Button
                      variant='contained'
                      color='success'
                      size='small'
                      onClick={() => {
                        let hasError = false;
                        if (!amountSettle || amountSettle < 0) {
                          setError('Invalid Amount');
                          hasError = true;
                        } else {
                          setError(null);
                        }
                        if (!note) {
                          setNoteError('Note is required');
                          hasError = true;
                        } else {
                          setNoteError(null);
                        }
                        if (!hasError) {
                          setIsSettle(true);
                        }
                      }}
                    >
                      {'Confirm'}
                    </Button>
                    <Button
                      variant='contained'
                      color='error'
                      size='small'
                      onClick={handleclose}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GroundSettlePaymentModal;
